import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBasket2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconBasket2"><Path d="M7.97901 8L9.80182 3.44298L7.94487 2.7002L5.82495 8H1.80469L4.16832 21H19.8375L22.2011 8H18.179L16.059 2.7002L14.2021 3.44298L16.0249 8H7.97901Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBasket2;
